// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabCmpEmpNoIabTitulo extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.cmp_emp_no_iab_titulo";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabCmpEmpNoIabTitulo {
        this.VALUES ??= this.completar({
            "valor": {
                "ca-ES": "Proveïdors que no pertanyen a IAB",
                "cz": "Další společnosti, které nejsou spojeny s IAB",
                "da": "Ikke-IAB-leverandører",
                "de": "Andere Unternehmen, die nicht mit dem IAB verbunden sind",
                "en": "Non-IAB Vendors",
                "eu-ES": "IABrekin loturarik ez duten beste enpresa batzuk",
                "fi": "Muut kuin IAB-toimittajat",
                "fr": "Autres partenaires non associés à l\\'IAB",
                "ga-ES": "Outras empresas non asociadas ao IAB",
                "hi": "अन्य कंपनियां IAB से जुड़ी नहीं हैं",
                "hu": "Nem IAB-szállítók",
                "it": "Altre società non associate alla IAB",
                "no": "Ikke-IAB-leverandører",
                "nl": "Overige bedrijven niet gelieerd aan het IAB",
                "pl": "Inne firmy niezwiązane z |AB",
                "pt": "Outras empresas não associadas à IAB",
                "pt-BR": "Outras empresas não associadas ao IAB",
                "ro": "Alte companii care nu sunt asociate cu IAB",
                "ru": "Компании, не являющиеся партнёрам IAB",
                "sk": "Ostatné spoločnosti, ktoré nie sú spojené s IAB",
                "sv": "Andra leverantörer som inte är associerade med IAB"
            },
            "defecto": "Otras empresas no asociadas a la IAB"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
